import React from "react";
import { useEffect,useContext,useState } from "react";
import { Link,useParams,useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { GlobalContext } from '../../GlobalContext';





const Header = ({sectionSession,location_p},ref) => {
   const { t, i18n } = useTranslation();
     const location = useLocation();
       let pathPrefix = location.pathname.split('/').length;
          
    
    if(pathPrefix > 2){
      pathPrefix = location.pathname.split('/')[0];
      pathPrefix = pathPrefix+'/img';
    }else{
        pathPrefix = 'img';
    }
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedlanguge, setSelectedOptionLanguge] = useState(null);
    
    const countryoptiondata = {
      
    };

    const languageoptiondata = {
     
    };

    const languageoptionsdata =[
      languageoptiondata
    ];

    const countryoptionsdata = [
      countryoptiondata
    ];
   
    const [default_country_data, setcountryData] = useState(countryoptiondata);
    const [default_language_data, setlanguageData] = useState(languageoptiondata);
    const [countryoptions, setOptionData] = useState(countryoptionsdata);
    const [languageoptions, setOptionlanguaeData] = useState(languageoptionsdata);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
      
    const { siteName } = useContext(GlobalContext);
    const { default_country } = useContext(GlobalContext);
    const { default_langage } = useContext(GlobalContext);
   
    const { setDefaultLangague } = useContext(GlobalContext);

    const { setDefaultCoutryDetails } = useContext(GlobalContext);
    const { setDefaultCoutry } = useContext(GlobalContext);
    const { setDefaultLangagueDetails } = useContext(GlobalContext);

      let baseUrl = siteName.baseUrl;
      let defult_endpoint = siteName.commonEndpoints;
      let local_country_languages_code = localStorage.getItem('local_country_languages');
      let local_country_languages_code_array;
      if(local_country_languages_code != null){
        local_country_languages_code_array = [];
      }else{
        local_country_languages_code_array = [];
      }
useEffect(() => {
  const fetchCountries = async () => {
    try {
      const response = await fetch(baseUrl + defult_endpoint + 'get/all/countries');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const countries = await response.json();

      
      const allcountries = countries.map((country) => {
        const item = {
          value: country.countryId,
          label: country.countryName,
          flag: 'https://flagcdn.com/w40/' + country.countryCode.toLowerCase() + '.png',
        };

         
        
        let local_country_iso_code = localStorage.getItem('local_country_iso_code');
        if(local_country_iso_code == country.countryCode){
          localStorage.setItem('default_country_code', country.countryId);
           let check_geo =  sessionStorage.getItem('geolocation');
           if(check_geo == null){
            setcountryData(item);
          setSelectedOption(item);
          localStorage.setItem("defult_country_details", JSON.stringify(item));
        setDefaultCoutryDetails(item);
        sessionStorage.setItem('geolocation',1)

            }

        }
        if (country.countryId === default_country) {
          setcountryData(item);
          setSelectedOption(item);
          localStorage.setItem("defult_country_details", JSON.stringify(item));
        setDefaultCoutryDetails(item);
        

        }
        return item;
      });
      localStorage.setItem('country_detils', JSON.stringify(allcountries));
      setOptionData(allcountries);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  fetchCountries();
}, []);
      /*language */
      useEffect(() => {
        const fetchLanguages = async () => {
          try {
            const response = await fetch(baseUrl + defult_endpoint + 'language/details');
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
      
            const languages = await response.json();
      
            const allLanguages = languages.map((lang) => {
              const item = {
                value: lang.languageId,
                isocode: lang.languageCode,
                label: lang.language,
              };
              
                if(local_country_languages_code_array.includes(lang.languageCode)){
                    setlanguageData(item);
                setSelectedOptionLanguge(item);
                setDefaultLangagueDetails(item);
                localStorage.setItem("defult_language_details", JSON.stringify(item));
                changeLanguage(item.isocode);
                }else{
                    if(lang.languageId === default_langage) {
                setlanguageData(item);
                setSelectedOptionLanguge(item);
                setDefaultLangagueDetails(item);
                localStorage.setItem("defult_language_details", JSON.stringify(item));
                changeLanguage(item.isocode);
              }
                }
            
      
              return item;
            });
      
            setOptionlanguaeData(allLanguages);
      
            // Optional: fallback to default if not found in loop
            if (default_language_data?.isocode) {
              changeLanguage(default_language_data.isocode);
            }
      
            setLoading(false);
          } catch (error) {
            setError(error);
            setLoading(false);
          }
        };
      
        fetchLanguages();
      }, []);
      

       useEffect(() => {
        const fetchnumber_file_d = async () => {
          try {
            const response = await fetch(baseUrl + 'web/settings/get/home/page/count');
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
      
            const homepge_number_count_detils = await response.json();
            let numberWithCommas = homepge_number_count_detils.homePageCount;
            
            let plainNumber = numberWithCommas.replace(/,/g, ""); 
            localStorage.setItem("homePageCount", plainNumber);
      console.log(plainNumber)
            // Optional: fallback to default if not found in loop
            
      
            setLoading(false);
          } catch (error) {
            setError(error);
            setLoading(false);
          }
        };
      
        fetchnumber_file_d();
      }, []);
      

      
  if (loading) console.log(loading);
  if (error) console.log(error);
       
      const formatOptionLabel = ({ label, flag }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={flag} alt="" style={{ width: 26, marginRight: 10,border: "1px solid #ddd" }} />
          {label}
        </div>
      );

      const formatOptionLabellanguage = ({ label, flag }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {label}
        </div>
      );

 
      /** 
       * 
       * 
      language part 
      ***/
 
       const changeLanguage = (lng) => {
      i18n.changeLanguage(lng)
    }

    const customStyles = {
      control: (provided) => ({
        ...provided,
        border: '1px solid #DDD',
        background:'transparent',
        boxShadow: 'none',
        borderRadius: '10px',
        color: '#000',
        '&:hover': {
          border: '1px solid #DDD',
        },
      })
    };

    const handleChange = (selected) => {

      setSelectedOption(selected);
      setcountryData(selected);
      setDefaultCoutryDetails(selected);
      localStorage.setItem("defult_country_details", JSON.stringify(selected));
      setDefaultCoutry(selected.value);
      /*Set localstorage*/
  
      localStorage.setItem('default_country_code', selected.value);
      
     window.location.reload();
      /*End localstorage*/
    };
    const handleChangelanguge = (selected) => {
     
      setSelectedOptionLanguge(selected)
   
      changeLanguage(selected.isocode);
      setlanguageData(selected);
       setDefaultLangagueDetails(selected)
       localStorage.setItem("defult_language_details", JSON.stringify(selected));
      setDefaultLangague(selected.value);
      localStorage.setItem('default_langage_code', selected.value);
      window.location.reload();
    }

    const { check_login_data } = useContext(GlobalContext);
    const { setLogin } = useContext(GlobalContext);
    const logout_action = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('loginbefore');
      localStorage.removeItem('role');
      setLogin(false);
      window.location.reload();
    };
   

  return (
    <header className="cfn-header-section">
         <div className="container desktop-header">
            <div className="header-wrapper d-flex">
                <div className="logo-column d-flex">
                <Link to="/"><span><img src="img/logo.svg" alt="One2One Logo"/></span></Link>
                    <div className="main-logo">
                    <Link to="/"><span><img  src="img/CfaN.png" alt="cFan Christ For All Nation"/></span></Link>
                    </div>
                </div>
                <div className="nav-menu-column">
                    <nav>
                    <ul className="header-menu-items">
                            <li><a href="https://cfan.org">{t('about_us')}</a></li>
                            <li><Link to="/#upcoming_section" onClick={sectionSession}>{t('Upcoming_Training_Sessions')}</Link></li>
                               <li><Link to="/requesttraining" >{t('request_a_training')}</Link></li>
                               <li><Link to="/requesttraining_one" >Request more info</Link></li>
                        </ul>
      
                    </nav>
                </div>
                <div className="header-btn-wrapper d-flex">
                    <div className="tranlate-menu">
                      
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown">
                              <span className="lang-flag"><img src={default_country_data.flag} alt=""/></span>{default_language_data.label}
                            </button>
                            <ul className="dropdown-menu" onClick={(e) => e.stopPropagation()}  aria-labelledby="dropdownMenuButton1">
                                <li>
                                <div className="dropdown-inner-content">
                                    <p>{t("Please_choose_your_location_Language")}</p>
                                    <div className="country-select-option">
                                        <div className="mul-lang-int">
                                        <Select styles={customStyles}
                                                options={countryoptions}
                                                value={selectedOption}
                                                onChange={handleChange}
                                                placeholder="Select a country..."
                                                isSearchable
                                                formatOptionLabel={formatOptionLabel}
                                                />
                                        </div>
                                    </div>
                                    <div className="language-select-option">
                                        <div className="mul-lang-int">
                                            <Select styles={customStyles}
                                                options={languageoptions}
                                                value={selectedlanguge}
                                                onChange={handleChangelanguge}
                                                placeholder="Select a Language..."
                                                isSearchable
                                                formatOptionLabel={formatOptionLabellanguage}
                                                />
                                        </div>
                                    </div>
                                </div>
                                </li>
                            </ul>
                          </div>
                    </div>
                    <div className="header-btn">
                        
                          {!check_login_data ?
                          <ul className="header-menu-items">
                            <li><span  data-bs-toggle="modal" data-bs-target="#trainerModal">{t("Trainers")}</span></li>
                            <div className="cfn-login-btn">
                                <li><span  className="cfn-global-btn" data-bs-toggle="modal" data-bs-target="#loginModal">{t("Login")}</span></li>
                            </div>
                            </ul>
                            :  <ul className="header-menu-items">
                            <li><Link to="/trainer">{t("Dashboard")}</Link></li>
                            <div className="cfn-login-btn">
                                <li><span  className="cfn-global-btn" onClick={logout_action}>{t("Log_out")}</span></li>
                            </div>
                            </ul>}
                        
                    </div>
                </div>
            </div>
        </div>


<nav class="navbar bg-light mobile-header">
<div class="container-fluid">
<div class="inner-header-mobile">
  <div class="mobile-logo">
  <a class="navbar-brand" href="#"><Link to="/"><span><img src="/img/logo.svg" alt="One2One Logo"/></span></Link></a>
</div>
<div class="mobile-inner-wrapper">
                              <div className="dropdown mobile-hide-col">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown">
                              <span className="lang-flag"><img src={default_country_data.flag} alt=""/></span>{default_language_data.label}
                            </button>
                            <ul className="dropdown-menu" onClick={(e) => e.stopPropagation()}  aria-labelledby="dropdownMenuButton1">
                                <li>
                                <div className="dropdown-inner-content">
                                    <p>{t("Please_choose_your_location_Language")}</p>
                                    <div className="country-select-option">
                                        <div className="mul-lang-int">
                                        <Select styles={customStyles}
                                                options={countryoptions}
                                                value={selectedOption}
                                                onChange={handleChange}
                                                placeholder="Select a country..."
                                                isSearchable
                                                formatOptionLabel={formatOptionLabel}
                                                />
                                        </div>
                                    </div>
                                    <div className="language-select-option">
                                        <div className="mul-lang-int">
                                            <Select styles={customStyles}
                                                options={languageoptions}
                                                value={selectedlanguge}
                                                onChange={handleChangelanguge}
                                                placeholder="Select a Language..."
                                                isSearchable
                                                formatOptionLabel={formatOptionLabellanguage}
                                                />
                                        </div>
                                    </div>
                                </div>
                                </li>
                            </ul>
                          </div>
<div className="header-btn">
        {!check_login_data ?
        <ul className="header-menu-items">
          <li><span  data-bs-toggle="modal" data-bs-target="#trainerModal">{t("Trainers")}</span></li>
          <div className="cfn-login-btn">
              <li><span  className="cfn-global-btn" data-bs-toggle="modal" data-bs-target="#loginModal">{t("Login")}</span></li>
          </div>
          </ul>
          :  <ul className="header-menu-items">
          <li><Link to="/trainer">{t("Dashboard")}</Link></li>
          <div className="cfn-login-btn">
              <li><span  className="cfn-global-btn" onClick={logout_action}>{t("Log_out")}</span></li>
          </div>
          </ul>}
  </div>
<div class="mobile-menu-option">
    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
  <span class="navbar-toggler-icon"></span>
</button>
<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
  <div class="offcanvas-header">
    <div className="logo-column d-flex">
    <Link to="/"><span><img src="/img/logo.svg" alt="One2One Logo"/></span></Link>
    <div className="main-logo">
    <Link to="/"><span><img  src="/img/CfaN.png" alt="cFan Christ For All Nation"/></span></Link>
    </div>
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
          <div className="nav-menu-column">
                <nav>
                <ul className="header-menu-items">
                        <li><Link to="/about" onClick={() => {
      setTimeout(() => {document.body.removeAttribute("style");},1000)
    
  
  }} >{t('about_us') }</Link></li>
                        <li><Link to="/#upcoming_section" onClick={sectionSession}>{t('Upcoming_Training_Sessions')}</Link></li>
                        <li><Link to="/requesttraining" onClick={() => {

                        setTimeout(() => {document.body.removeAttribute("style");},1000)

                        }}>{t("request_a_training")}</Link></li>
                        <li><Link to="/about" onClick={() => {

      setTimeout(() => {document.body.removeAttribute("style");},1000)
  
  }}>{t("Beliefs")}</Link></li>
                        <li><Link to="/member/2" onClick={() => {

     setTimeout(() => {document.body.removeAttribute("style");},1000)
  
  }}>{t("Reinhard_Bonnke")}</Link></li>
                        <li><Link to="/about" onClick={() => {

     setTimeout(() => {document.body.removeAttribute("style");},1000)
  
  }}>{t("History")}</Link></li>
                        <li><Link to="/member/1" onClick={() => {
  setTimeout(() => {document.body.removeAttribute("style");},1000)
  
  }}>{t("Daniel_Kolenda")}</Link></li>
                        <li><Link to="/privacypolice" onClick={() => {

      setTimeout(() => {document.body.removeAttribute("style");},1000)
  
  }}>{t("Privacy_Policy")}</Link></li>
                                    <li><Link to="/termsandconditions" onClick={() => {

      setTimeout(() => {document.body.removeAttribute("style");},1000)
  
  }}>{t("Terms_Conditions")}</Link></li>
                    </ul>


                                        <div className="tranlate-menu">
                      
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown">
                              <span className="lang-flag"><img src={default_country_data.flag} alt=""/></span>{default_language_data.label}
                            </button>
                            <ul className="dropdown-menu" onClick={(e) => e.stopPropagation()}  aria-labelledby="dropdownMenuButton1">
                                <li>
                                <div className="dropdown-inner-content">
                                    <p>{t("Please_choose_your_location_Language")}</p>
                                    <div className="country-select-option">
                                        <div className="mul-lang-int">
                                        <Select styles={customStyles}
                                                options={countryoptions}
                                                value={selectedOption}
                                                onChange={handleChange}
                                                placeholder="Select a country..."
                                                isSearchable
                                                formatOptionLabel={formatOptionLabel}
                                                />
                                        </div>
                                    </div>
                                    <div className="language-select-option">
                                        <div className="mul-lang-int">
                                            <Select styles={customStyles}
                                                options={languageoptions}
                                                value={selectedlanguge}
                                                onChange={handleChangelanguge}
                                                placeholder="Select a Language..."
                                                isSearchable
                                                formatOptionLabel={formatOptionLabellanguage}
                                                />
                                        </div>
                                    </div>
                                </div>
                                </li>
                            </ul>
                          </div>
                    </div>
                </nav>
            </div>
  </div>
</div>
</div>
</div>
</div>
</div>
</nav>

    </header>
  );
};

export default Header;